<template>
  <div id="app">

    <div style="background-color:#4c1c17 !important;" v-if="getPermissao() == 3 ">
      <img src="/img/cab.png" class="img-fluid mx-auto d-block" />
      <p class="text-center text-white pb-2">  Olá, {{getUsuario()}}</p> 

     
    </div> 

<!-- menu -->
 <div id="appMenu" class="" v-if="getPermissao() == 1 ||  getPermissao() == 2 ||  getPermissao() == 4">
<nav style="background-color:#4c1c17 !important;" class="navbar navbar-expand-lg navbar-dark bg-dark" v-if="this.$route.path !== '/'">
  <a class="navbar-brand" href="#"><img src="/img/logo.png" class="img-responsive" /></a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        
         <router-link to="/busca" class="nav-link">Busca</router-link> 
      </li>

       <li class="nav-item" v-if="getPermissao() == 1">
      
         <router-link to="/buscaLocacoes" class="nav-link">Locações</router-link> 
      </li>

         <li class="nav-item" >
           <router-link to="/buscaLeads" class="nav-link">Leads</router-link> 
      </li>

      <li class="nav-item" >
           <router-link to="/buscaLeadsLocacao" class="nav-link">Leads Locação</router-link> 
      </li>

        <li class="nav-item" >
           <router-link to="/propostas" class="nav-link">Propostas</router-link> 
      </li>

      <li class="nav-item" v-if="getPermissao() == 1">
      
         <router-link to="/cidade" class="nav-link">Cidades</router-link> 
      </li>

        <li class="nav-item" v-if="getPermissao() == 1">
           <router-link to="/edificio" class="nav-link">Edificios</router-link> 
     
      </li>

      

       <li class="nav-item" v-if="getPermissao() == 1">
           <router-link to="/usuario" class="nav-link">Usuarios</router-link> 
     
      </li>

      <li class="nav-item ml-5" >
           <a href="#" class="nav-link" > | Olá {{getUsuario()}}</a> 
     
      </li>
     
    
    </ul>
    
  </div>
</nav>
<br><br>
</div>
<!-- -->
 


<div id="app" class="container">
    <router-view/>
</div><!-- container -->

</div><!-- app -->
</template>

<script>
export default {
   name: 'Busca',
   methods:{
     getUsuario(){
       return sessionStorage.getItem('imobiliariaNome');
     },
     getPermissao(){
       return sessionStorage.getItem('imobiliaria');
     }
   }
}
</script>

<style>

</style>

